/*jslint browser: true*/
/*global $, jQuery, alert, dialogNew, dialogClose, Modulis, moment*/

$.extend({
    createElement : function (elementName) {
        "use strict";
        return $(document.createElement(elementName));
    }
});

function kombinaceDruhuStareDefiniceDuplikovat(element) {
    "use strict";
    var elDefinice = $(element).parents('.kombinaceDruhuStare-definice'),
        elKombinace = elDefinice.parents('.kombinaceDruhuStare-kombinace'),
        nova = elDefinice.clone();

    nova.find('input[type="hidden"]').remove();
    nova.appendTo(elKombinace);
    kombinaceDruhuStareDefinicePreindexovat(elKombinace);

    return false;
}

function kombinaceDruhuStareDefinicePreindexovat(elBlok) {
    "use strict";
    var prefix = $(elBlok).parents('.kombinaceDruhuStare-b3').data('prefix');

    $(elBlok).find('.kombinaceDruhuStare-definice').each(function(indexDefinice, elDefinice) {
        indexDefinice++;
        $(elDefinice).attr('data-definice', indexDefinice);
        $(elDefinice).find('label, input, textarea, select, div.box-header').each(function (b, element) {
            if (element.getAttribute('name') !== null) {
                var regex = new RegExp( prefix + '\\[([0-9]+)\\]');
                element.name = element.name.replace(regex, prefix + '[' + indexDefinice + ']');
            }

            if (element.getAttribute('id') !== null) {
                var regex = new RegExp(prefix + '-([0-9]+)-');
                element.id = element.id.replace(regex, prefix + '-' + indexDefinice + '-');
            }

            if (element.getAttribute('for') !== null) {
                var regex = new RegExp(prefix + '-([0-9]+)-');
                element.setAttribute('for', element.getAttribute('for').replace(regex, prefix + '-' + indexDefinice + '-'));
            }
        });
    });
}

function kombinaceDruhuStareDefinicePridat(element) {
    "use strict";
    var elBlok = $(element).parents('.kombinaceDruhuStare-b3'),
        elKombinace = $(element).parents('.kombinaceDruhuStare-b3').find('.kombinaceDruhuStare-kombinace'),
        prefix = $(elBlok).data('prefix'),
        indexDefinice = $(elBlok).find('.kombinaceDruhuStare-definice').length + 1,

        divBox = $(document.createElement('div'))
            .attr('class', 'box box-primary kombinaceDruhuStare-definice')
            .attr('data-definice', indexDefinice),

        divBoxHeader = $(document.createElement('div'))
            .attr('class', 'box-header with-border')
            .attr('id',  prefix + '-' + indexDefinice + '-hlavicka'),

        divBoxBody = $(document.createElement('div'))
            .attr('class', 'box-body'),

        divBoxFooter = $(document.createElement('div'))
            .attr('class', 'box-footer'),

        pPridatSkupinu = $(document.createElement('p'))
            .attr('class', 'margin-top-5 margin-bottom-5 text-center'),

        hlavicka = kombinaceDruhuStareDefiniceHlavicka(divBoxHeader, prefix, indexDefinice),

        table = $(document.createElement('table'))
            .attr('class', 'table table-bordered table-striped kombinaceDruhuStare-skupina')
            .attr('data-skupina', 1),

        thead = $(document.createElement('thead')),
        theadTr = $(document.createElement('tr')),
        tbody = $(document.createElement('tbody')),
        tfoot = $(document.createElement('tfoot')),
        tfootTr = $(document.createElement('tr')),

        theadThDruh = $(document.createElement('th')).html('Druh').attr('class', 'width-25'),
        theadThHodnota = $(document.createElement('th')).html('Hodnota').attr('class', 'width-40'),
        theadThOd = $(document.createElement('th')).html('Od').attr('class', 'width-10'),
        theadThDo = $(document.createElement('th')).html('Do').attr('class', 'width-10'),
        theadThPresne = $(document.createElement('th')).html('Přesně').attr('class', 'width-10'),
        theadThSmazat = $(document.createElement('th')).attr('class', 'width-5'),
        tfootTdLeva = $(document.createElement('td')).attr('colspan', '6'),

        buttonPridatPodminku = $(document.createElement('button'))
            .attr('class', 'kombinaceDruhuStare-podminka-pridat btn btn-xs btn-primary'),

        buttonPridatPodminkuIcon = $(document.createElement('i'))
            .attr('class', 'fas fa-plus fa-fw');

    theadTr.append(theadThDruh);
    theadTr.append(theadThHodnota);
    theadTr.append(theadThOd);
    theadTr.append(theadThDo);
    theadTr.append(theadThPresne);
    theadTr.append(theadThSmazat);

    thead.append(theadTr);

    buttonPridatPodminku
        .append(buttonPridatPodminkuIcon)
        .append(' Přidat podmínku');

    tfootTdLeva.append(buttonPridatPodminku);

    tfootTr.append(tfootTdLeva);

    tfoot.append(tfootTr);

    table.append(thead);
    table.append(tbody);
    table.append(tfoot);

    var buttonDuplikovat = $(document.createElement('button'))
        .attr('class', 'kombinaceDruhuStare-definice-duplikovat btn btn-xs btn-primary'),

        buttonDuplikovatIcon = $(document.createElement('i'))
        .attr('class', 'fas fa-copy fa-fw'),

        buttonSmazat = $(document.createElement('button'))
        .attr('class', 'kombinaceDruhuStare-definice-smazat btn btn-xs btn-primary'),

        buttonSmazatIcon = $(document.createElement('i'))
        .attr('class', 'fas fa-trash fa-fw'),

        divPatickaRow = $(document.createElement('div'))
        .attr('class', 'row'),

        divPatickaCol = $(document.createElement('div'))
        .attr('class', 'col-sm-12 text-right');

    if ('balickyDopPodminky' !== prefix && 'prirazkySrazky' !== prefix) {
        buttonDuplikovat
            .append(buttonDuplikovatIcon)
            .append(' Duplikovat definici');
        buttonSmazat
            .append(buttonSmazatIcon)
            .append(' Smazat definici');

        divPatickaCol.append(buttonDuplikovat);
        divPatickaCol.append(' ');
        divPatickaCol.append(buttonSmazat);
        divPatickaRow.append(divPatickaCol);
        divBoxFooter.append(divPatickaRow);
    }

    if ('balickyDopPodminky' !== prefix && 'prirazkySrazky' !== prefix) {
        divBoxHeader.append(hlavicka);
        divBox.append(divBoxHeader);
    }

    divBoxBody.append(table);

    divBox.append(divBoxBody);
    divBox.append(divBoxFooter);

    $(elKombinace).append(divBox);

    return false;
}

function kombinaceDruhuStareDefiniceSmazat(element) {
    "use strict";
    var elDiv = $(element).parent(),
        elDefinice = $(elDiv).parents('.kombinaceDruhuStare-definice'),
        elBlok = $(elDiv).parents('.kombinaceDruhuStare-b3').find('.kombinaceDruhuStare-kombinace'),
        elKombinace = $(elBlok).find('.kombinaceDruhuStare-kombinace'),
        elDefiniceId = $(elDiv).find(':hidden'),
        prefix = $(element).parents('.kombinaceDruhuStare-b3').data('prefix');

    if ($(elDefiniceId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', prefix + '-smazaneDefinice[]')
            .val($(elDefiniceId).val());

        $('#' + prefix).append(el);
    }

    $(elDefinice).remove();

    kombinaceDruhuStareDefinicePreindexovat(elKombinace);

    return false;
}

function kombinaceDruhuStarePodminkaNactiHodnoty(elementName, idDruh) {
    "use strict";
    var element = $('#' + elementName),
        prefix = element.parents('div.kombinaceDruhuStare-b3').data('prefix'),
        elementDataHodnoty = $('#' + prefix + '-data-hodnoty-' + idDruh);

    element.children().remove();

    if (elementDataHodnoty.children().length >= 1) {
        element.html(elementDataHodnoty.html());

        element.removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).addClass('hidden').val('');
        $('#' + elementName.replace('idHodnota', 'do')).addClass('hidden').val('');
        $('#' + elementName.replace('idHodnota', 'presne')).addClass('hidden').val('');
    } else {
        element.addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'do')).removeClass('hidden');
        $('#' + elementName.replace('idHodnota', 'presne')).removeClass('hidden');
    }

    if (idDruh === '' || idDruh === 0) {
        element.addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'od')).addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'do')).addClass('hidden');
        $('#' + elementName.replace('idHodnota', 'presne')).addClass('hidden');
    }
}

function kombinaceDruhuStarePodminkaPreindexovat(elTabulka) {
    "use strict";
    $(elTabulka).find('tbody > tr').each(function (indexPodminka, elTr) {
        indexPodminka++;
        $(elTr).attr('data-podminka', indexPodminka);
        $(elTr).find('input, textarea, select').each(function (b, element) {
            if (element.getAttribute('name') != null) {
                element.name = element.name.replace(/podminky\]\[(\d+)\]/, 'podminky][' + indexPodminka + ']');
            }

            if (element.getAttribute('id') != null) {
                element.id = element.id.replace(/-podminky-(\d+)-/, '-podminky-' + indexPodminka + '-');
            }
        });
    });
}

function kombinaceDruhuStarePodminkaPridat(element) {
    "use strict";
    var elSkupina = $(element).parents('.kombinaceDruhuStare-skupina'),
        indexDefinice = $(element).parents('.kombinaceDruhuStare-definice').data('definice'),
        indexPodminka = $(elSkupina).find('tbody > tr').length + 1,
        prefix = $(element).parents('.kombinaceDruhuStare-b3').data('prefix'),
        onkeydown = "return keyPress(this.id, event),",

        tr = $(document.createElement('tr'))
                 .attr('class', 'kombinaceDruhuStare-podminka')
                 .attr('data-podminka', indexPodminka),

        td1 = $(document.createElement('td')),
        td2 = $(document.createElement('td')),
        td3 = $(document.createElement('td')),
        td4 = $(document.createElement('td')),
        td5 = $(document.createElement('td')),
        td6 = $(document.createElement('td'))
            .attr('class', 'text-center'),

        selectIdDruh = $(document.createElement("select"))
            .attr('id', prefix + '-' + indexDefinice + '-podminky-' + indexPodminka + '-idDruh')
            .attr('name', prefix + '[' + indexDefinice + '][podminky][' + indexPodminka + '][idDruh]')
            .attr('class', 'form-control input-sm idDruh')
            .html($('#' + prefix + '-data-druhy').html()),

        selectIdHodnota = $(document.createElement("select"))
            .attr('id', prefix + '-' + indexDefinice + '-podminky-' + indexPodminka + '-idHodnota')
            .attr('name', prefix + '[' + indexDefinice + '][podminky][' + indexPodminka + '][idHodnota]')
            .attr('class', 'form-control input-sm hidden'),

        inputOd = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-podminky-' + indexPodminka + '-od')
            .attr('name', prefix + '[' + indexDefinice + '][podminky][' + indexPodminka + '][od]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        inputDo = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-podminky-' + indexPodminka + '-do')
            .attr('name', prefix + '[' + indexDefinice + '][podminky][' + indexPodminka + '][do]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        inputPresne = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-podminky-' + indexPodminka + '-presne')
            .attr('name', prefix + '[' + indexDefinice + '][podminky][' + indexPodminka + '][presne]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        inputSazba = $(document.createElement("input"))
            .attr('type', 'text')
            .attr('id', prefix + '-' + indexDefinice + '-podminky-' + indexPodminka + '-sazba')
            .attr('name', prefix + '[' + indexDefinice + '][podminky][' + indexPodminka + '][sazba]')
            .attr('class', 'form-control input-sm text-right hidden')
            .attr('size', 4)
            .attr('onkeydown', onkeydown),

        hrefSmazat = '<button class="kombinaceDruhuStare-podminka-smazat btn btn-xs btn-danger"><i class="fas fa-trash fa-fw"></a>';

    td1.append(selectIdDruh);
    td2.append(selectIdHodnota);
    td3.append(inputOd);
    td4.append(inputDo);
    td5.append(inputPresne);
    td6.append(hrefSmazat);

    tr.append(td1);
    tr.append(td2);
    tr.append(td3);
    tr.append(td4);
    tr.append(td5);
    tr.append(td6);

    $(elSkupina).find('tbody').append(tr);

    return false;
}

function kombinaceDruhuStarePodminkaSmazat(element) {
    "use strict";
    var elTabulka = $(element).parents('table'),
        elTd = $(element).parents('td'),
        elPodminkaId = $(elTd).find(':hidden'),
        prefix = $(element).parents('.kombinaceDruhuStare-b3').data('prefix');

    if ($(elPodminkaId).length > 0) {
        var el = $.createElement('input')
            .attr('type', 'hidden')
            .attr('name', prefix + '-smazanePodminky[]')
            .val($(elPodminkaId).val());

        $('#' + prefix).append(el);
    }

    $(element).parents('tr').remove();

    kombinaceDruhuStarePodminkaPreindexovat(elTabulka);
}

function kombinaceDruhuStareDefiniceHlavicka(divBoxHeader, prefix, indexDefinice) {
    "use strict";
// ELEMENTY

    var inputBody = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][body]')
            .attr('id', prefix + '-' + indexDefinice + '-body')
            .attr('class', 'form-control'),

        inputBonus = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][bonus]')
            .attr('id', prefix + '-' + indexDefinice + '-bonus')
            .attr('class', 'form-control text-right'),

        inputCastka = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][castka]')
            .attr('id', prefix + '-' + indexDefinice + '-castka')
            .attr('class', 'form-control text-right'),

        inputDuvod = $(document.createElement('textarea'))
            .attr('name', prefix + '[' + indexDefinice + '][duvod]')
            .attr('id', prefix + '-' + indexDefinice + '-duvod')
            .attr('class', 'form-control')
            .attr('rows', 2)
            .attr('placeholder', 'Zobrazuje se s prefixem Nelze pojistit:'),

        inputIdentifikator = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][identifikator]')
            .attr('id', prefix + '-' + indexDefinice + '-identifikator')
            .attr('class', 'form-control'),

        inputKod = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][kod]')
            .attr('id', prefix + '-' + indexDefinice + '-kod')
            .attr('class', 'form-control'),

        inputKoeficient = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][koeficient]')
            .attr('id', prefix + '-' + indexDefinice + '-koeficient')
            .attr('class', 'form-control'),

        inputMaximum = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][maximum]')
            .attr('id', prefix + '-' + indexDefinice + '-maximum')
            .attr('class', 'form-control text-right'),

        inputNazev = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][nazev]')
            .attr('id', prefix + '-' + indexDefinice + '-nazev')
            .attr('class', 'form-control'),

        inputNezobrazitMeziChybamiNaKalkulaciHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][nezobrazitMeziChybamiNaKalkulaci]')
            .val(0),

        inputNezobrazitMeziChybamiNaKalkulaci = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][nezobrazitMeziChybamiNaKalkulaci]')
            .attr('id', prefix + '-' + indexDefinice + '-nezobrazitMeziChybamiNaKalkulaci')
            .val(1),

        inputPevnaSoucastHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][pevnaSoucast]')
            .val(0),

        inputPevnaSoucast = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][pevnaSoucast]')
            .attr('id', prefix + '-' + indexDefinice + '-pevnaSoucast')
            .val(1),

        inputPopis = $(document.createElement('textarea'))
            .attr('name', prefix + '[' + indexDefinice + '][popis]')
            .attr('id', prefix + '-' + indexDefinice + '-popis')
            .attr('class', 'form-control')
            .attr('rows', 3),

        inputPricistHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][pricist]')
            .val(0),

        inputPricist = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][pricist]')
            .attr('id', prefix + '-' + indexDefinice + '-pricist')
            .val(1),

        inputProcent = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][procent]')
            .attr('id', prefix + '-' + indexDefinice + '-procent')
            .attr('class', 'form-control text-right'),

        inputSazbaa = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][sazba]')
            .attr('id', prefix + '-' + indexDefinice + '-sazba')
            .attr('class', 'form-control text-right'),

        inputSazba = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][sazba]')
            .attr('id', prefix + '-' + indexDefinice + '-sazba')
            .attr('class', 'form-control text-right'),

        inputSleva = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][sleva]')
            .attr('id', prefix + '-' + indexDefinice + '-sleva')
            .attr('class', 'form-control text-right'),

        inputSkupina = $(document.createElement('input'))
            .attr('type', 'text')
            .attr('name', prefix + '[' + indexDefinice + '][skupina]')
            .attr('id', prefix + '-' + indexDefinice + '-skupina')
            .attr('class', 'form-control'),

        inputVychoziStavHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][vychoziStav]')
            .val(0),

        inputVychoziStav = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][vychoziStav]')
            .attr('id', prefix + '-' + indexDefinice + '-vychoziStav')
            .val(1),

        inputZobrazitUzivateliHidden = $(document.createElement('input'))
            .attr('type', 'hidden')
            .attr('name', prefix + '[' + indexDefinice + '][zobrazitUzivateli]')
            .val(0),

        inputZobrazitUzivateli = $(document.createElement('input'))
            .attr('type', 'checkbox')
            .attr('name', prefix + '[' + indexDefinice + '][zobrazitUzivateli]')
            .attr('id', prefix + '-' + indexDefinice + '-zobrazitUzivateli')
            .val(1),

        selectDruhBS = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][druh]')
            .attr('id', prefix + '-' + indexDefinice + '-druh')
            .attr('class', 'form-control druhBonusoveSlevy')
            .append('<option value="bonus">Bonus</option>')
            .append('<option value="sleva">Sleva</option>'),

        selectIdBalicek = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][idBalicek]')
            .attr('id', prefix + '-' + indexDefinice + '-idBalicek')
            .attr('class', 'form-control'),

        selectKrok = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][krok]')
            .attr('id', prefix + '-' + indexDefinice + '-krok')
            .attr('class', 'form-control text-right'),

        selectMaximum = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][maximum]')
            .attr('id', prefix + '-' + indexDefinice + '-maximum')
            .attr('class', 'form-control text-right'),

        selectNasobek = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][nasobek]')
            .attr('id', prefix + '-' + indexDefinice + '-nasobek')
            .attr('class', 'form-control')
            .append('<option value="0">Žádný</option>')
            .append('<option value="1">1x</option>')
            .append('<option value="2">2x</option>')
            .append('<option value="3">3x</option>')
            .append('<option value="4">4x</option>')
            .append('<option value="5">5x</option>'),

        selectIdSazba = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][idSazba]')
            .attr('id', prefix + '-' + indexDefinice + '-idSazba')
            .attr('class', 'form-control')
            .attr('disabled', true).prop('disabled', true)
            .append('<option value="">-</option>'),

        selectIdTyp = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][idTyp]')
            .attr('id', prefix + '-' + indexDefinice + '-idTyp')
            .attr('class', 'form-control'),

        selectTypPojistneho = $(document.createElement('select'))
            .attr('name', prefix + '[' + indexDefinice + '][typPojistneho]')
            .attr('id', prefix + '-' + indexDefinice + '-typPojistneho')
            .attr('class', 'form-control')
            .append('<option value="">-</option>')
            .append('<option value="rocniPojistne">Roční pojistné</option>')
            .append('<option value="rocniPojistneProNasobek">Roční pojistné pro násobek</option>')
            .append('<option value="koeficient">Koeficient</option>'),

// HODNOTY PRO SELECTY

        mesice = [0, 12, 24, 36, 48, 60, 72, 84, 96, 108, 120];
    $.each(mesice, function (i, mesic) {
        selectMaximum.append('<option value="' +  mesic + '">' +  mesic + '</option>');
    });

    for (var i=1; i<=50; i++) {
        selectKrok.append('<option value="' +  i + '">' +  i + '</option>');
    }

    if(prefix === 'doplnkovaPojisteniDruhy') {
        selectIdTyp.html($('#typyDruhu').html());
    }
    if(prefix === 'nelzePojistitDop') {
        selectIdBalicek.html($('#nelzePojistitDop-data-druhyDoplnkovychPojisteni').html());
    }

// BLOKY

    var divBody = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-body" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-body" class="control-label col-sm-6">Body</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputBody).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divBonus = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-bonus" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-bonus" class="control-label col-sm-6">Bonus</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputBonus).prop('outerHTML') +
        '            <div class="input-group-addon">m</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divCastka = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-castka" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-castka" class="control-label col-sm-6">Částka</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputCastka).prop('outerHTML') +
        '            <div class="input-group-addon">Kč</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divDruhBS = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-druh" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-druh" class="control-label col-sm-6">Druh</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(selectDruhBS).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divDruhDop = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-idTyp" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-idTyp" class="control-label col-sm-6">Druh</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(selectIdTyp).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divDuvod = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-duvod" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-duvod" class="control-label col-sm-6">Důvod</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputDuvod).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divIdentifikator = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-identifikator" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-identifikator" class="control-label col-sm-6">Identifikátor</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputIdentifikator).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divKod = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-kod" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-kod" class="control-label col-sm-6">Kód</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputKod).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divKoeficient = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-koeficient" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-koeficient" class="control-label col-sm-6">Koeficient</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputKoeficient).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divKrok = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-krok" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-krok" class="control-label col-sm-6">Krok po</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(selectKrok).prop('outerHTML') +
        '            <div class="input-group-addon">%</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divNazev = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-nazev" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-nazev" class="control-label col-sm-6">Název</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputNazev).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divMaximumInput = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-maximum" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-maximum" class="control-label col-sm-6">Maximální výše</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputMaximum).prop('outerHTML') +
        '            <div class="input-group-addon">m</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divMaximumSelect = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-maximum" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-maximum" class="control-label col-sm-6">Maximální výše</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '      ' + $(selectMaximum).prop('outerHTML') +
        '            <div class="input-group-addon">měsíců</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divMinimalniPojistne = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-sazba" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-sazba" class="control-label col-sm-6">Minimální pojistné</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputSazbaa).prop('outerHTML') +
        '            <div class="input-group-addon">Kč</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divNasobek = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-nasobek" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-nasobek" class="control-label col-sm-6">Násobek</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(selectNasobek).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divNezobrazitMeziChybamiNaKalkulaci = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-nezobrazitMeziChybamiNaKalkulaci" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-nezobrazitMeziChybamiNaKalkulaci" class="control-label col-sm-6">Nezobrazovat mezi chybami na kalkulaci</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputNezobrazitMeziChybamiNaKalkulaciHidden).prop('outerHTML') +
        '      ' + $(inputNezobrazitMeziChybamiNaKalkulaci).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPevnaSoucast = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-pevnaSoucast" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-pevnaSoucast" class="control-label col-sm-6">Pevná součást poj.</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputPevnaSoucastHidden).prop('outerHTML') +
        '      ' + $(inputPevnaSoucast).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPopis = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-popis" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-popis" class="control-label col-sm-6">Popis</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputPopis).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPricist = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-pricist" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-pricist" class="control-label col-sm-6">Přičíst k vlastnímu bonusu</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputPricistHidden).prop('outerHTML') +
        '      ' + $(inputPricist).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divPripojisteni = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-idBalicek" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-idBalicek" class="control-label col-sm-6">Připojištění</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(selectIdBalicek).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divProcent = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-procent" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-procent" class="control-label col-sm-6">Procent</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputProcent).prop('outerHTML') +
        '            <div class="input-group-addon">%</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divSazba = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-sazba" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-sazba" class="control-label col-sm-6">Sazba</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputSazba).prop('outerHTML') +
        '            <div class="input-group-addon">Kč</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divIdSazba = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-idSazba" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-idSazba" class="control-label col-sm-6">Sazba</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(selectIdSazba).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divSleva = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-sleva" class="form-group form-group-sm hidden">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-sleva" class="control-label col-sm-6">Sleva</label>' +
        '    <div class="col-sm-6">' +
        '        <div class="input-group">' +
        '            ' + $(inputSazba).prop('outerHTML') +
        '            <div class="input-group-addon">%</div>' +
        '        </div>' +
        '    </div>' +
        '</div>'
    );

    var divSkupina = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-skupina" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-skupina" class="control-label col-sm-6">Skupina</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputSkupina).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divTypPojistneho = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-typPojistneho" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-typPojistneho" class="control-label col-sm-6">Typ pojistného</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(selectTypPojistneho).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divVychoziStav = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-vychoziStav" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-vychoziStav" class="control-label col-sm-6">Vybráno ve výchozím stavu</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputVychoziStav).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

    var divZobrazitUzivateli = $(
        '<div id="' + prefix + '-' + indexDefinice + '-hlavicka-zobrazitUzivateli" class="form-group form-group-sm">' +
        '    <label for="' + prefix + '-' + indexDefinice + '-zobrazitUzivateli" class="control-label col-sm-6">Zobrazit uživateli</label>' +
        '    <div class="col-sm-6">' +
        '      ' + $(inputZobrazitUzivateliHidden).prop('outerHTML') +
        '      ' + $(inputZobrazitUzivateli).prop('outerHTML') +
        '    </div>' +
        '</div>'
    );

// SESTAVENI HLAVICKY
    if(prefix === 'bonusoveSlevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divIdentifikator).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPopis).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divDruhBS).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSleva).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divBonus).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divVychoziStav).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'doplnkovaPojisteniDruhy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divDruhDop).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divTypPojistneho).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNasobek).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPevnaSoucast).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'koeficienty') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divKod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSkupina).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKoeficient).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'jednorazoveSlevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divIdentifikator).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divCastka).prop('outerHTML') + '</div>' +
            '</div>' +
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divVychoziStav).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'maximalniSlevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divProcent).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKoeficient).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'minimalniPojistne') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divMinimalniPojistne).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'nelzePojistit') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divDuvod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divNezobrazitMeziChybamiNaKalkulaci).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divZobrazitUzivateli).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'nelzePojistitDop') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divDuvod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPripojisteni).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divIdSazba).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'prevodBonusu') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4">' + $(divMaximumSelect).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'skutecnaVybava') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divBody).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'skutecneZabezpeceni') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSkupina).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'slevy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divKrok).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divMaximumInput).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'vernostniBonusy') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divMaximumSelect).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divPricist).prop('outerHTML') + '</div>' +
            '</div>'
        );
    }
    if(prefix === 'zabezpeceni') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divNazev).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }
    if(prefix === 'zakladniSazby') {
        divBoxHeader.append(
            '<div class="row">' +
            '    <div class="col-sm-4">' + $(divKod).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4">' + $(divSazba).prop('outerHTML') + '</div>' +
            '    <div class="col-sm-4"></div>' +
            '</div>'
        );
    }

    return divBoxHeader;
}

function kombinaceDruhuStarePreindexujTabulky(prefix) {
    "use strict";

    $('#' + prefix).find('div[id$=\'-blok\']').each(function(a, element) {
        a++;

        // Preindexujeme ID bloku
        element.id = element.id.replace(/(\d+)/, a);

        // Preindexujeme ID bloku, tabulky a radku
        $(element).find('div, table, tr').each(function(b, subElement) {
            subElement.id = subElement.id.replace(/-(\d+)-/, '-' + a + '-');
        });


        // Preindexujeme elementy v hlavicce bloku
        $('#' + prefix + '-' + a + '-hlavicka').find('input, select').each(function(b, subElement)
        {
            if(subElement.getAttribute('id') != null) {
                subElement.id = subElement.id.replace(/(\d+)/, a);
            }

            if(subElement.getAttribute('name') != null) {
                subElement.name = subElement.name.replace(/(\d+)/, a);
            }
        });

        // Preindexujeme elementy uvnitr tabulky
        $('#' + prefix + '-' + a + '-tabulka').find('a, input, select, textarea').each(function(b, subElement)
        {
            if(subElement.getAttribute('id') != null) {
                subElement.id = subElement.id.replace(/-(\d+)-podminky-(\d+)-/, '-' + a + '-podminky-$2-');
            }

            if(subElement.getAttribute('name') != null) {
                subElement.name = subElement.name.replace(/\[(\d+)\]\[podminky\]\[(\d+)\]/, '[' + a + '][podminky][$2]');
            }

            if(subElement.getAttribute('for') != null) {
                subElement.setAttribute('for', subElement.getAttribute('for').replace(/-(\d+)-podminky-(\d+)-/, '-' + a + '-podminky-$2-'));
            }

            if(subElement.getAttribute('onclick') != null) {
                subElement.setAttribute('onclick', subElement.getAttribute('onclick').replace(/(\d+),/, a + ','));
            }
        });
    });
}

$(document).ready(function() {
    "use strict";
    var kombinaceDruhuStare = $('.kombinaceDruhuStare-b3');

    kombinaceDruhuStare.on('change', '.idDruh', function () {
        var id = $(this).attr('id').replace('idDruh', 'idHodnota');
        var value = $(this).val();

        kombinaceDruhuStarePodminkaNactiHodnoty(id, value);
    });

    $('.kombinaceDruhuStare-definice-pridat').on('click', function () {
        kombinaceDruhuStareDefinicePridat(this);

        return false;
    });

    kombinaceDruhuStare.on('click', '.kombinaceDruhuStare-definice-duplikovat', function (e) {
        e.preventDefault();
        kombinaceDruhuStareDefiniceDuplikovat(this);

        return false;
    });

    kombinaceDruhuStare.on('click', '.kombinaceDruhuStare-definice-smazat', function () {
        kombinaceDruhuStareDefiniceSmazat(this);

        return false;
    });

    kombinaceDruhuStare.on('click', '.kombinaceDruhuStare-podminka-pridat', function () {
        kombinaceDruhuStarePodminkaPridat(this);

        return false;
    });

    kombinaceDruhuStare.on('click', '.kombinaceDruhuStare-podminka-smazat', function () {
        kombinaceDruhuStarePodminkaSmazat(this);

        return false;
    });
});
